var Education = "การศึกษา";
var Enterprise = "Enterprise";
var CompanyType = {
	"Company type": "ประเภทบริษัท",
	Education: Education,
	Enterprise: Enterprise,
	"Government - Federal": "รัฐบาล - ส่วนกลาง",
	"Government - State & local": "รัฐบาล - รัฐและส่วนท้องถิ่น",
	"Non-profit": "ไม่หวังผลกำไร",
	"Self employed": "ธุรกิจส่วนตัว",
	"Small-medium business": "ธุรกิจขนาดเล็กและขนาดกลาง",
	"Start-up": "สตาร์ทอัพ",
	"Not applicable": "ไม่เกี่ยวข้อง"
};

export { Education, Enterprise, CompanyType as default };
